import React from 'react';
import './Page.scss';

function Page({
    header,
    children
}) {


    return <div className="page">
        {header && <h1 className="page-header">
            {header}
        </h1>}
        {children}
    </div>
}

export default Page;